import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ModalProvider, ToastContainer } from '@leroy-merlin-br/backyard-react'
import { Minimal } from '@leroy-merlin-br/backpack-header'

import reactComponentLoader from 'scripts/react-component-loader'

import AlgoliaInstantSearch from 'shared/contexts/AlgoliaInstantSearch/AlgoliaInstantSearch'

import CartDrawer from '../Header/components/Cart/components/CartDrawer'
import { NewHeader } from '.'
import { CartDrawerProvider } from '../Header/contexts/CartDrawerContext'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

interface HeaderProps {
  /**
   * Feature flip to black-friday
   */
  isBlackWeekend?: boolean

  /**
   * Feature flip to enable/disable social provider
   */
  socialLoginProviders?: Array<'google' | 'facebook' | 'apple'>
}

export function Header (props: HeaderProps) {
  const { isBlackWeekend = false, socialLoginProviders = [] } = props

  const PAGE_TYPE = document.querySelector('[data-page-type][data-type]')
    ?.dataset.type

  const IS_SEARCH_TYPE =
    PAGE_TYPE === 'search' ||
    PAGE_TYPE === 'mappedSearch' ||
    PAGE_TYPE === 'entryKey'

  const Component = (
    <NewHeader
      socialLoginProviders={socialLoginProviders}
      isBlackWeekend={isBlackWeekend}
    />
  )

  return (
    <QueryClientProvider client={queryClient}>
      <CartDrawerProvider>
        <ModalProvider>
          <ToastContainer position="top-right" />
          {IS_SEARCH_TYPE ? (
            Component
          ) : (
            <AlgoliaInstantSearch>{Component}</AlgoliaInstantSearch>
          )}
          <CartDrawer />
        </ModalProvider>
      </CartDrawerProvider>
    </QueryClientProvider>
  )
}

reactComponentLoader(Header, '[data-backpack-header]')
reactComponentLoader(Minimal, '[data-backpack-header-clean]')
